import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React from 'react';
import { FormContext } from '../context/FormContext';
import fieldsHelper from '../utils/fieldsHelper';
/**
 * @param {import('./types').EcrionFormState} state
 * @param {import('./types').EcrionFormField} field
 */

var getFocusedFieldIndex = function getFocusedFieldIndex(state, field) {
  return fieldsHelper.findFieldIndex(state, field);
};

var getFocusedField = function getFocusedField(state, fieldId) {
  if (!fieldId || !state.fields) return {}; // state not ready

  var field = state.fields[fieldId];
  if (!field) return {};
  return {
    name: field.name,
    id: field.originalId || field.id,
    index: getFocusedFieldIndex(state, field),
    type: field.type
  };
};
/**
 * @param {string} fieldId Unique field id
 * @returns {any}
 */


var useFormFieldState = function useFormFieldState(fieldId) {
  var formContext = React.useContext(FormContext);
  if (!formContext) return {};

  var _formContext = _slicedToArray(formContext, 1),
      state = _formContext[0];

  if (!state || !state.meta) return {};
  if (fieldId === 'FOCUSED_FIELD') return getFocusedField(state, state.meta['FOCUSED_FIELD']);
  return {};
};

export default useFormFieldState;